/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import StarRegular from './star-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <StarRegular {...validProps} />;
}
SvgComponent.iconName = 'star-regular';

export const StarRegularIcon = svgIconWrapper(SvgComponent);
